<template>
	<div>
		<modal ref="modal">
			<div class="conteiner">
				<div class="header">
					<div class="row">
						<div class="col-md-11 col-xs-10 pull-left" style="display: flex;">
							<h4 class="modal-title">
								{{ _traducao('global', 'novo').toUpperCase() }} {{ _traducao('global', 'voo').toUpperCase() }}
							</h4>
						</div>
						<div class="col-md-1 col-xs-2 pull-right">
							<button type="button" class="close" @click="fecharModal()">
								<span aria-hidden="true">&times;</span>
							</button>            
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<hr />
						</div>
					</div>
				</div>

				<!-- lista com dos despachos -->
				<div class="content">
          <div class="row" style="margin-bottom: 15px;">
						<div class="col-xs-12">
							<p class="text-info" style="color: black;">
							  {{ _traducao('global', 'desejaSelecionarvoo').toUpperCase() }}
							</p>
						</div>
					</div>

          <div class="row" style="margin-top: 4px">
						<div class="col-md-12 col-xs-12 form-group">
				      <label>* {{ _traducao('global', 'voo').toUpperCase() }}:</label>
              <select
                v-model="form.id_malha"
                class="form-control input-sm"
              >
                <option value="0">
                  {{ _traducao('global', 'escolha').toUpperCase() }}
                </option>
                <option
                  v-for="voo in voos"
                  :key="voo.id"
                  :value="voo.id"
                >
                  {{ voo.numero_voo }}
                </option>
              </select>
            </div>
					</div>
				</div>
          
				<div class="footer">
					<div class="row" style="margin-top: auto; margin-bottom: 8px">
						<div class="col-xs-12">
							<hr />
						</div>
            <div class="col-md-4 col-xs-6" style="">
							<button
								type="button"
								@click="$refs.modal.modalHide()"
								class="btn btn-block pull-right"
							>
              <i class="fa fa-times" aria-hidden="true"></i>
								{{ _traducao('global', 'fechar').toUpperCase() }}
							</button>
						</div>
            <div class="col-md-4" style=""></div>
						<div class="col-md-4 col-xs-6" style="">
							<button
								type="button"
								@click.prevent="copiar"
								class="btn btn-block btn-success pull-right"
							>
								<i class="fa fa-check" aria-hidden="true"></i>
								{{ _traducao('global', 'criar').toUpperCase() }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>
<script>
export default {
	props: {
    
	},

	data() {
		return {
			form:{id_malha: 0},
			voos: [],
		}
	},
	methods: {
		async carregaVooMalha() {
			window.bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
			this.voos = await this.carregaVoos()
			if(this.voos.length >= 1){
				this.$refs.modal.modalShow(30)
			}
			window.bus.$emit('load-out');			
		},

		async carregaVoos() {
			return new Promise((resolve) => {
				this._axios('/Malha_voo/get_voos_copia', 'get', {
					callback: (retorno) => {
						if (retorno._request && retorno._status) {
							resolve(retorno.lista)
						}
					}
				})
			})
		},

		copiar() {
			this.$emit('copiar-voo', this.form)
			this.$refs.modal.modalHide()
		},

		fecharModal(){
			this.$refs.modal.modalHide()
		},
	},
}
		
</script>
<style scoped>
.conteiner{
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  min-height: 300px;
}

.header {
  position: sticky;
  top: 0;
}

.content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.footer {
  bottom: 0;
}
</style>